/**
 * Operator-facing wording for every configuration problem (TASK-0076).
 *
 * This module exists so the wording has exactly one home without dragging a dependency graph into `main.tsx`: the entry
 * point needs these sentences to explain a failed start-up, but it must not import the API client (through `env`) before
 * the configuration is known. Keeping them here means `startupError`, `configureRuntime` and the tests share one copy
 * while the entry chunk stays free of anything that reads configuration.
 */

import type { ConfigurationProblemCode } from '@/lib/runtimeConfig';

/** One English sentence per problem code, naming the reason and never a configured value. */
export const PROBLEM_MESSAGES: Record<ConfigurationProblemCode, string> = {
  unavailable:
    'the runtime configuration file could not be read (it is missing, or the host refused it)',
  malformed: 'the runtime configuration file is not valid JSON, or is not a JSON object',
  not_an_object: 'the runtime configuration file must contain a JSON object',
  missing: 'no API address is configured',
  invalid_url: 'the configured API address is not an absolute http or https URL',
  same_origin_disabled: 'a relative API address is not allowed by this deployment',
  same_origin_contradicted:
    'a relative API address cannot reach the API from this page (there is no reverse proxy)',
};
